module.exports = __webpack_public_path__ + "static/media/bg.379d97b8.png";